"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDuplicateLayout = exports.EntityDuplicateLayoutDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var html_1 = require("../elements/html");
var icon_1 = require("../elements/icon");
var open_graph_cell_1 = require("./open-graph-cell");
var cls = (0, utils_1.classNames)('entity-duplicate-layout');
exports.EntityDuplicateLayoutDefaultProps = {
  items: [],
  variant: 'default'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", "em;\n    border-top: 1px solid ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    text-align: left;\n  "], ["\n    background-color: ", ";\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", "em;\n    border-top: 1px solid ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    text-align: left;\n  "])), theme_1.theme.COLOR('canvas'), theme_1.theme.UNIT(5), theme_1.theme.FONT_SIZE(15), 24 / 14, theme_1.theme.COLOR('line-subtle'))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "])))
});
var QuestionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "])))
});
var IndicatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    opacity: 0.1;\n    align-self: center;\n  "], ["\n    opacity: 0.1;\n    align-self: center;\n  "])))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n    margin: 0;\n    list-style-type: none;\n    padding: 0;\n  "], ["\n    width: 100%;\n    margin: 0;\n    list-style-type: none;\n    padding: 0;\n  "])))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin: 0;\n    text-align: left;\n    box-sizing: border-box;\n    border-top: 1px solid ", ";\n    padding: ", " ", ";\n    background: ", ";\n    width: 100%;\n    ", "\n  "], ["\n    margin: 0;\n    text-align: left;\n    box-sizing: border-box;\n    border-top: 1px solid ", ";\n    padding: ", " ", ";\n    background: ", ";\n    width: 100%;\n    ", "\n  "])), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(4.5), theme_1.theme.UNIT(5), theme_1.theme.COLOR('light'), function (_a) {
    var linked = _a.linked;
    return linked && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      cursor: pointer;\n      transition: transform 0.3s;\n      &:hover {\n        transform: scale(1.02, 1.02);\n      }\n    "], ["\n      cursor: pointer;\n      transition: transform 0.3s;\n      &:hover {\n        transform: scale(1.02, 1.02);\n      }\n    "])));
  })
});
var EntityStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Info: styled_components_1.default.p(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Question: styled_components_1.default.p(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), QuestionStyles),
  Indicator: (0, styled_components_1.default)(icon_1.Icon)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), IndicatorStyles),
  Items: styled_components_1.default.ul(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.li(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Entity: (0, styled_components_1.default)(open_graph_cell_1.OpenGraphCell)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), EntityStyles)
};
var EntityDuplicateLayout = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items,
    name = props.name,
    variant = props.variant,
    onLink = props.onLink,
    entityTypeName = props.entityTypeName;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var config = definition.duplicateDialogConfig;
  var t = (0, use_lang_1.useLang)();
  var templates = config.templates[variant];
  var icons = (0, use_icons_1.useIcons)();
  var strings = (0, react_1.useMemo)(function () {
    return {
      continueLabel: (0, sprintf_js_1.sprintf)(t(config.continueLabel), definition.label),
      cancelLabel: (0, sprintf_js_1.sprintf)(t(config.cancelLabel), definition.label),
      title: (0, sprintf_js_1.sprintf)(t(config.title), definition.label),
      info: (0, sprintf_js_1.sprintf)(t(templates.info), definition.aLabel, name),
      question: (0, sprintf_js_1.sprintf)(t(templates.question), definition.label),
      linkLabel: (0, sprintf_js_1.sprintf)(t(config.linkLabel), definition.label)
    };
  }, [entityTypeName, items, variant]);
  var existingTemplate = t(items.length > 1 ? 'Existing Record %d' : 'Existing Record');
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Info, null, react_1.default.createElement(html_1.HTML, {
    text: strings.info
  })), react_1.default.createElement(My.Question, null, react_1.default.createElement(html_1.HTML, {
    text: strings.question
  })), react_1.default.createElement(My.Indicator, {
    size: 48
  }, react_1.default.createElement(icons.ChevronDown, null))), react_1.default.createElement(My.Items, null, items.map(function (entity, index) {
    return react_1.default.createElement(My.Item, {
      linked: variant === 'linked',
      onClick: variant === 'linked' && onLink ? function () {
        return onLink(entity.id);
      } : null,
      key: entity.id
    }, react_1.default.createElement(My.Entity, {
      imageWidth: "20%",
      badge: variant === 'linked' && items.length > 1 ? t('Link This Record') : (0, sprintf_js_1.sprintf)(existingTemplate, index + 1),
      entity: entity
    }));
  })));
};
exports.EntityDuplicateLayout = EntityDuplicateLayout;
exports.EntityDuplicateLayout.defaultProps = exports.EntityDuplicateLayoutDefaultProps;
exports.EntityDuplicateLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;